import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend,ChartDataLabels);

export default function PieChart({ data, ...props }) {
  return <Pie options={{ plugins: {
    legend: {
      display: true,
      labels: {
        font: {
          size: 14
        }
      },
    },
    tooltip: {
      callbacks: {
        label: (context) => {
          return context.formattedValue + '%'
        }
      }
    },
    datalabels :{
      display: false
    }
  }, }} data={data} { ...props } />;
}
